import debounce from 'lodash/debounce'

const updateViewportUnit = () => {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
}

window.addEventListener('resize', debounce(updateViewportUnit, 50))
updateViewportUnit()
